(function () {
  function showStatus(status, message, state) {
    status.textContent = message;
    status.classList.remove('is-success', 'is-error');
    status.classList.add('is-visible');
    if (state) status.classList.add(state);
  }

  function licenseMessageForResponse(response, data) {
    if (response.status === 404) {
      return "We couldn't find an active license for that email. Check that it matches the email used for your purchase.";
    }
    if (response.status === 429) {
      return 'Too many attempts. Please wait 15 minutes and try again.';
    }
    if (response.status === 400) {
      return 'Enter a valid email address.';
    }
    return data && data.message
      ? data.message
      : "We couldn't send your license codes right now. Please try again.";
  }

  function initLicenseForm(section) {
    var form = section.querySelector('[data-license-request-form]');
    if (!form || form.dataset.licenseRequestReady === 'true') return;

    var status = form.querySelector('[data-license-request-status]');
    var email = form.querySelector('input[name="email"]');
    var plugin = form.querySelector('select[name="plugin"]');
    var button = form.querySelector('button[type="submit"]');
    var label = form.querySelector('[data-license-request-label]');
    var endpoint = String(form.dataset.recoveryEndpoint || '').trim();

    if (!status || !email || !plugin || !button || !label || !endpoint) return;

    var requestedProduct = new URLSearchParams(window.location.search).get('plugin');
    if (requestedProduct === 'halftone-creator') {
      plugin.value = requestedProduct;
    }

    form.dataset.licenseRequestReady = 'true';

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      var normalizedEmail = String(email.value || '').trim().toLowerCase();
      var selectedProduct = String(plugin.value || '').trim();
      if (!email.checkValidity() || !normalizedEmail) {
        showStatus(status, 'Enter the email address used for your purchase.', 'is-error');
        email.focus();
        return;
      }
      if (!plugin.checkValidity() || !selectedProduct) {
        showStatus(status, 'Select the plugin whose license you want to recover.', 'is-error');
        plugin.focus();
        return;
      }

      button.disabled = true;
      label.textContent = 'Sending...';
      status.classList.remove('is-visible', 'is-success', 'is-error');

      try {
        var response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: normalizedEmail,
            product: selectedProduct
          })
        });
        var data = await response.json().catch(function () { return {}; });

        if (!response.ok) {
          showStatus(status, licenseMessageForResponse(response, data), 'is-error');
          return;
        }

        showStatus(
          status,
          'We sent your license code to that email. Please also check your spam folder.',
          'is-success'
        );
      } catch (error) {
        showStatus(
          status,
          "We couldn't contact the license service. Please try again.",
          'is-error'
        );
      } finally {
        button.disabled = false;
        label.textContent = 'Get License';
      }
    });
  }

  function feedbackMessageForResponse(response, data) {
    if (response.status === 429) {
      return 'Too many submissions. Please wait 15 minutes and try again.';
    }
    if (response.status === 400) {
      return data && data.message ? data.message : 'Check the information and try again.';
    }
    return data && data.message
      ? data.message
      : "We couldn't send your feedback right now. Please try again.";
  }

  function initFeedbackForm(section) {
    var form = section.querySelector('[data-feedback-form]');
    if (!form || form.dataset.feedbackReady === 'true') return;

    var status = form.querySelector('[data-feedback-status]');
    var email = form.querySelector('input[name="email"]');
    var plugin = form.querySelector('select[name="plugin"]');
    var message = form.querySelector('textarea[name="message"]');
    var button = form.querySelector('button[type="submit"]');
    var label = form.querySelector('[data-feedback-submit-label]');
    var endpoint = String(form.dataset.feedbackEndpoint || '').trim();

    if (!status || !email || !plugin || !message || !button || !label || !endpoint) return;

    var requestedProduct = new URLSearchParams(window.location.search).get('plugin');
    if (requestedProduct === 'organizer' || requestedProduct === 'halftone-creator') {
      plugin.value = requestedProduct;
    }

    form.dataset.feedbackReady = 'true';

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      var normalizedEmail = String(email.value || '').trim().toLowerCase();
      var selectedProduct = String(plugin.value || '').trim();
      var comment = String(message.value || '').trim();

      if (!form.reportValidity()) return;
      if (!normalizedEmail || !selectedProduct || comment.length < 3) {
        showStatus(status, 'Complete all fields before sending.', 'is-error');
        return;
      }

      button.disabled = true;
      label.textContent = 'Sending...';
      status.classList.remove('is-visible', 'is-success', 'is-error');

      try {
        var response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: normalizedEmail,
            product: selectedProduct,
            message: comment
          })
        });
        var data = await response.json().catch(function () { return {}; });

        if (!response.ok) {
          showStatus(status, feedbackMessageForResponse(response, data), 'is-error');
          return;
        }

        form.reset();
        showStatus(
          status,
          data.message || 'Thank you. Your feedback was sent successfully.',
          'is-success'
        );
      } catch (error) {
        showStatus(
          status,
          "We couldn't contact the feedback service. Please try again.",
          'is-error'
        );
      } finally {
        button.disabled = false;
        label.textContent = 'Send feedback';
      }
    });
  }

  function initSection(section) {
    initLicenseForm(section);
    initFeedbackForm(section);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-license-contact]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
